import HeaderLocations from "@/components/sections/header-locations";
import { contactIconList } from "@/lib/data";
import { Component } from "@builder.io/sdk";

export const headerLocationsConfig: Component = {
  name: "Header Locations",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "header-locations",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "headingClassName",
      type: "string",
      helperText: "Tailwind CSS classes for the heading text",
      advanced: true,
    },
    {
      name: "subheadingClassName",
      type: "string",
      helperText: "Tailwind CSS classes for the subheading text",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      friendlyName: "Heading",
      defaultValue: "Find Exceptional Home Care Services Across the Bay Area",
      helperText: "Main heading for the header section",
      required: true,
    },
    {
      name: "subheading",
      type: "longText",
      friendlyName: "Subheading",
      defaultValue: "Compassionate Support Near You",
      helperText: "Subheading text below the main heading",
      required: true,
    },
    {
      name: "contactList",
      friendlyName: "Detail Items",
      type: "list",
      helperText: "Used for the Location pages header",
      subFields: [
        {
          name: "icon",
          type: "string",
          enum: contactIconList,
        },
        {
          name: "text",
          type: "string",
        },
        {
          name: "url",
          type: "string",
        },
      ],
    },
    {
      name: "showPrimaryCTA",
      type: "boolean",
      defaultValue: true,
      friendlyName: "Show Primary Button",
      helperText: "Do you want to show the primary button?",
    },
    {
      name: "primaryCTA",
      friendlyName: "Primary Button",
      type: "object",
      showIf: "options.get('showPrimaryCTA') === true",

      subFields: [
        {
          name: "className",
          type: "string",
          helperText: "Tailwind CSS classes for the button",
          advanced: true,
        },
        {
          name: "color",
          type: "string",
          enum: ["orange", "teal", "gray", "orange-light"],
          friendlyName: "Button Color",
          helperText: "Color for the primary button",
        },
        {
          name: "children",
          type: "string",
          friendlyName: "Button Text",
          helperText: "Text for the primary button",
          required: true,
        },
        {
          name: "href",
          friendlyName: "Button Link",
          type: "string",
          helperText: "Link for the primary button",
          required: true,
        },
      ],
      defaultValue: {
        color: "orange",
        children: "Get a Free Consultation",
        href: "/care-assessment",
      },
    },
    {
      name: "showSecondaryCTA",
      type: "boolean",
      defaultValue: true,
      friendlyName: "Show Secondary Button",
      helperText: "Do you want to show the secondary button?",
    },
    {
      name: "secondaryCTA",
      friendlyName: "Secondary Button",
      type: "object",
      showIf: "options.get('showSecondaryCTA') === true",
      subFields: [
        {
          name: "className",
          type: "string",
          helperText: "Tailwind CSS classes for the button",
          advanced: true,
        },
        {
          name: "color",
          type: "string",
          enum: ["orange", "teal", "gray", "light"],
          friendlyName: "Button Color",
          helperText: "Color for the secondary button",
        },
        {
          name: "children",
          type: "string",
          friendlyName: "Button Text",
          helperText: "Text for the secondary button",
          required: true,
        },
        {
          name: "href",
          type: "string",
          friendlyName: "Button Link",
          helperText: "Link for the secondary button",
          required: true,
        },
      ],
      defaultValue: {
        color: "teal",
        children: "Learn more",
        href: "/contact-us",
      },
    },
    {
      name: "breadcrumbs",
      friendlyName: "Breadcrumbs",
      helperText: "Breadcrumb navigation for the page",
      type: "object",
      subFields: [
        {
          name: "data",
          friendlyName: "Breadcrumb",
          type: "list",
          subFields: [
            {
              name: "name",
              friendlyName: "Display Name",
              type: "string",
              helperText: "Display name for the breadcrumb",
              required: true,
            },
            {
              name: "href",
              friendlyName: "Link",
              type: "string",
              helperText: "Link for the breadcrumb",
              required: true,
            },
          ],
          defaultValue: [
            {
              href: "/families",
              name: "Services for Families",
            },
          ],
        },
      ],
    },
    {
      name: "image",
      friendlyName: "Header Image",
      type: "object",
      required: true,
      defaultValue: {
        src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F89e121a6c263458ab7bb4d76b6f7b6ea",
        alt: "Locations Header Image",
      },
      subFields: [
        {
          name: "src",
          type: "file",
          friendlyName: "Image",
          allowedFileTypes: ["jpeg", "png"],
          helperText: "Header image file",
        },
        {
          name: "alt",
          friendlyName: "Alt Text",
          type: "string",
        },
      ],
    },
  ],
};

export default HeaderLocations;
